import { Box } from "@ecco/ui/box";
import { styles } from "./EccoClubCardsStyles";
import { Text } from "@ecco/ui/text";
import { Button } from "@ecco/ui/button";
import { useGlobalModalContext } from "@components/GlobalModalProvider/GlobalModalProvider";
import { defaultUnderlineStyle } from "@ecco/ui/css/common";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { CommonCMS } from "@lib/constants/contentful";
import { useLoyaltyTransaction } from "@store/hooks/customerHooks/loyaltyTransactions";
import { hasPointsAndTiers } from "@lib/utils/loyalty";

export default function MembershipCard(props) {
    const { showModal } = useGlobalModalContext();
    const { getMultiple } = useMicrocopy();

    const { data: loyaltyTransactionData } = useLoyaltyTransaction();

    const microcopies = (() => {
        return getMultiple(CommonCMS.shared, [
            CommonCMS.loyalty.openYourEccoPass,
            CommonCMS.loyalty.tierLevel,
            CommonCMS.loyalty.pointsBalance,
            CommonCMS.loyalty.openYourBalanceHistory,
            CommonCMS.loyalty.earnPointsToReachTier,
            CommonCMS.loyalty.pointsExpireIn,
        ]);
    })();
    const commonButtonProps = {
        size: "sm",
        variant: "unstyled",
        colorScheme: "black",
        fontWeight: "bold",
        h: "auto",
        px: 0,
        gap: 2,
    };

    const shouldShowUpcomingTier =
        (loyaltyTransactionData?.upcomingTier?.pointsToNextTier ?? 0).toString() !== "0";

    const shouldShowPointsExpiration =
        (loyaltyTransactionData?.pointsExpiration?.totalPointsToExpire ?? 0).toString() !== "0";

    return (
        <Box style={styles.membershipCardContainer}>
            <Box style={styles.membershipPointsContainer}>
                {hasPointsAndTiers && (
                    <Box style={styles.membershipPointsInnerContainer}>
                        <Box style={styles.tierLevelInfoContainer}>
                            <Text
                                fontSize={"lg"}
                                fontWeight={"normal"}
                                style={{ ...defaultUnderlineStyle }}
                            >
                                {microcopies[CommonCMS.loyalty.tierLevel]}
                            </Text>
                            <Text fontSize={"5xl"} fontWeight={"bold"}>
                                {props.tierLevel.toString().toUpperCase()}
                            </Text>
                        </Box>
                        <Box style={styles.tierLevelInfoContainer}>
                            <Button
                                onClick={() => showModal("eccoClubBalanceHistory")}
                                {...commonButtonProps}
                                display="flex"
                                flexDirection="column"
                                alignItems="flex-start"
                                sx={{
                                    _hover: {
                                        color: "gray.700",
                                        textDecorationColor: "gray.700",
                                    },
                                }}
                            >
                                <Text
                                    fontSize={"lg"}
                                    fontWeight={"bold"}
                                    style={{ ...defaultUnderlineStyle }}
                                >
                                    {microcopies[CommonCMS.loyalty.pointsBalance]}
                                </Text>
                                <Text fontSize={"5xl"} fontWeight={"bold"}>
                                    {props.pointsBalance}
                                </Text>
                            </Button>
                        </Box>
                    </Box>
                )}
                {hasPointsAndTiers && (
                    <Box style={styles.nextTier}>
                        {shouldShowUpcomingTier && (
                            <Text fontSize={"lg"} fontWeight={"normal"}>
                                {(() => {
                                    const earnPointsText =
                                        microcopies[CommonCMS.loyalty.earnPointsToReachTier] ?? "";
                                    const [beforePoints, afterPoints] =
                                        earnPointsText.split(/\{\{x-points\}\}/);
                                    return (
                                        <>
                                            {beforePoints}
                                            <span style={{ fontWeight: "bold" }}>
                                                {loyaltyTransactionData?.upcomingTier
                                                    ?.pointsToNextTier ?? "N/A"}
                                            </span>
                                            {afterPoints}
                                            <span style={{ fontWeight: "bold" }}>
                                                {loyaltyTransactionData?.upcomingTier?.nextTier ??
                                                    "N/A"}
                                            </span>
                                        </>
                                    );
                                })()}
                            </Text>
                        )}
                        {shouldShowPointsExpiration && (
                            <Text fontSize={"lg"} fontWeight={"normal"} color={"red.600"}>
                                {(() => {
                                    const expireText =
                                        microcopies[CommonCMS.loyalty.pointsExpireIn] ?? "";
                                    const [beforePoints, afterPointsBeforeDays, afterDays] =
                                        expireText.split(/\{\{x-points\}\}|\{\{x-days\}\}/);
                                    return (
                                        <>
                                            {beforePoints}
                                            <span style={{ fontWeight: "bold" }}>
                                                {loyaltyTransactionData?.pointsExpiration
                                                    ?.totalPointsToExpire ?? "N/A"}
                                            </span>
                                            {afterPointsBeforeDays}
                                            <span style={{ fontWeight: "bold" }}>
                                                {loyaltyTransactionData?.pointsExpiration
                                                    ?.daysToExpire ?? "N/A"}
                                            </span>
                                            {afterDays}
                                        </>
                                    );
                                })()}
                            </Text>
                        )}
                    </Box>
                )}

                <Box style={styles.buttonsContainer}>
                    {hasPointsAndTiers && (
                        <Button
                            variant={"tertiary"}
                            onClick={() => showModal("eccoClubBalanceHistory")}
                            w="100%"
                            maxW={{ base: "100%", md: "320px" }}
                        >
                            {microcopies[CommonCMS.loyalty.openYourBalanceHistory]}
                        </Button>
                    )}

                    <Button
                        display={{ base: "flex", lg: "none" }}
                        variant={"tertiary"}
                        onClick={() => showModal("eccoPass")}
                        w="100%"
                        maxW={{ base: "100%", md: "320px" }}
                    >
                        {microcopies[CommonCMS.loyalty.openYourEccoPass]}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}
